import React from 'react';
import styled from '@emotion/styled';
import {
  fontSize,
  fontWeight,
  spacing,
  borderRadius,
  mediaMax,
} from 'presentations/views/styles';
import {
  primary,
  black,
  white,
  gray02,
  gray03,
  gray04,
  gray06,
  blue02,
  secondary,
  whiteFix,
} from 'presentations/views/styles/color';
import { imagePath } from 'presentations/assets';
import ResourceShareList from 'presentations/views/components/organisms/ResourceShareList';
import { formatToDate } from 'infras/datetime';
import Head from 'next/head';
import { careerPath, webPath } from 'presentations/routes/path';
import { useRouter } from 'next/router';
import { CareerItem } from 'presentations/api/schema/contents';
import { translate } from 'infras/i18n';
import { BodyContainer } from '../BlogContent';

export interface Props {
  item: CareerItem;
}

export default function Component(props: Props) {
  const router = useRouter();
  const shareUrl = webPath(careerPath(props.item.slug), router.locale);

  return (
    <ContentWrapper>
      <Head>
        {props.item.thumbnailUrl && (
          <link rel="preload" href={props.item.thumbnailUrl} as="image" />
        )}
      </Head>
      <ContentContainer>
        {/* {props.item.thumbnailUrl && (
          <HeaderImageContainer>
            <HeaderImage
              src={props.item.thumbnailUrl}
              alt={props.item.title}
              width={672}
              height={448}
            />
          </HeaderImageContainer>
        )} */}
        <Title>{props.item.title}</Title>
        <InfomationContainer>
          <TagList>
            <TagListItem>
              {translate(`career.category.${props.item.category}`)}
            </TagListItem>
            {props.item.isRemote && (
              <TagListItem>{translate('career.remote')}</TagListItem>
            )}
          </TagList>
          <CreatedAt>{formatToDate(props.item.updatedAt)}</CreatedAt>
        </InfomationContainer>
        <div id="js-resource-body">
          <BodyContainer
            dangerouslySetInnerHTML={{ __html: props.item.body }}
          />
        </div>
      </ContentContainer>
      <SideShareIconContainer>
        <SideShareIconStickyWrapper>
          <SideShareIconSticky>
            <ResourceShareList
              shareTitle={props.item.title}
              shareUrl={shareUrl}
            />
          </SideShareIconSticky>
        </SideShareIconStickyWrapper>
      </SideShareIconContainer>
    </ContentWrapper>
  );
}

const ContentWrapper = styled.div`
  position: relative;
`;

const ContentContainer = styled.div``;

const HeaderImageContainer = styled.div`
  width: 672px;
  height: 448px;
  position: relative;

  ${mediaMax.tablet} {
    width: 100%;
    height: auto;
    min-height: 198px;
    margin: ${spacing(20)} 0 0 0;
  }
`;

const HeaderImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${borderRadius()};
`;

const Title = styled.h1`
  font-size: ${fontSize(28)};
  font-weight: ${fontWeight('bold')};
  line-height: 1.4;
  letter-spacing: 0.05em;
  overflow-wrap: break-word;

  ${mediaMax.tablet} {
    font-size: ${fontSize(20)};
  }
`;

const InfomationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: row;
  margin-top: ${spacing(20)};
  padding-bottom: ${spacing(24)};
  border-bottom: 1px solid ${gray04};
`;
const TagList = styled.div`
  display: flex;
`;
const TagListItem = styled.div`
  padding: ${spacing(2)} ${spacing(8)};
  font-size: ${fontSize(13)};
  color: ${primary};
  border: 1px solid ${primary};
  border-radius: ${borderRadius(3)};
  margin-right: ${spacing(8)};
  :last-of-type {
    margin-right: 0;
  }
`;

const CreatedAt = styled.span`
  display: flex;
  align-items: center;

  font-size: ${fontSize(14)};
  line-height: 160%;
  color: ${gray02};

  ${mediaMax.tablet} {
    font-size: ${fontSize(12)};
  }
`;

const SideShareIconContainer = styled.div`
  position: absolute;
  top: 20px;
  left: -72px;
  height: 100%;

  ${mediaMax.tablet} {
    display: none;
  }
`;

const SideShareIconStickyWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const SideShareIconSticky = styled.div`
  position: sticky;
  top: 96px;
  left: 0;
  height: auto;
`;
